<template>
	<div class="Ccon">
		<div id="container"></div>
		<div @click="getLine" class="btn">移动</div>
	</div>

</template>

<script>
	import { isFinite } from 'core-js/core/number'
import {
		pointData,cityList
	} from '../utils/tools'
	import request from "../utils/request.js"
	import {mapKey} from "../utils/api.js"
	export default {
		name: 'index',
		data() {
			return {
				map: null,
				position: null,
				roation: null,
				marker: null,
				trail: null,
				markerData: [],
				trailData: [],
				path: [],
				colorOffset: [],
				center: {
					latitude: 40.040523,
					longitude: 116.273654
				},
				durationTime:50,
				speed:0,
				pointData2:null,
				
				// mapZoom:14

			}
		},
		computed:{
			mapZoom(){
				console.log("速度"+this.speed)
				if(speed<300){
					return 17
				}
				
				let speedArea = {
					300:17,
					1000:16,
					500:15,
					10000:14,
					50000:13,
					100000:12,
					1000000:11
				}
				
				if(speed>300){
					return 17
				}
			}
		},
		mounted() {
			this.initMap()
			this.initMarker()
			// this.initPath()
			this.initTrail()
			// this.carMove()
		},
		methods: {
			getLine(){
			
				let baseUrl = "/tencent-map/ws/direction/v1/driving/?"
				
				let url = `${baseUrl}from=31.230525,121.473667&to=22.186927,113.543076&key=${mapKey}`
				
				request(url).then(res=>{
					const consp = res.result.routes[0]
					let route = consp.polyline
					for (var i = 2; i < route.length ; i++){
						route[i] = route[i-2] + route[i]/1000000
					}
					let arr = this.dealPolyline(route)
					this.markerData = arr
					this.carMove()
					// console.log(arr)
				})
			},
			dealPolyline(coords){
				let point = []
				let len = coords.length
				let index = 0
				while(index<len){
					// 增加越界判断，避免 undefined 错误
					if (index + 1 >= len) break;
					let ide = Math.floor(len/100)
					let qwe = ide % 2 === 0 ? ide : ide - 1;
					this.path.push([coords[index], coords[index+1]])
					point.push(new TMap.LatLng(coords[index], coords[index+1]))
					if(len<30){
						index+=2
					}else{
						index+=qwe
					}
				}
				
				this.trailData.push({
					path: this.path,
				})
				
				return point
				
			},
			car2(event) {
				// console.log("222222")
				let len = this.calcPathTotal(pointData).toFixed(2)
				console.log(len)
			},
			getDistanceBetweenPoints(lat1, lng1, lat2, lng2) {
				// 将经纬度转换为弧度
				let toRadians = (degree) => degree * (Math.PI / 180);
				let R = 6371; // 地球半径（单位：千米）

				let dLat = toRadians(lat2 - lat1);
				let dLng = toRadians(lng2 - lng1);
				let a =
					Math.sin(dLat / 2) * Math.sin(dLat / 2) +
					Math.cos(toRadians(lat1)) *
					Math.cos(toRadians(lat2)) *
					Math.sin(dLng / 2) *
					Math.sin(dLng / 2);
				let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				return R * c; // 返回千米单位
			},
			calcPathTotal(path) {
				if (path.length < 2) return 0; // 至少需要两个点

				let totalDistance = 0;
				for (let i = 1; i < path.length; i++) {
					let prev = path[i - 1];
					let curr = path[i];
					totalDistance += this.getDistanceBetweenPoints(
						prev.lat, prev.lng,
						curr.lat, curr.lng
					);
				}
				let num = totalDistance*1000
				let speed = 0
				speed =Number(num/this.durationTime.toFixed(3))
				this.speed = speed
				console.log("速度"+this.speed)
				return speed
			},
			getTime(type, duration) {
				let time = new Date().getTime()
				if (type == 'start') {
					return time
				} else {
					console.log("结束时间")
					console.log(time + duration * 100)
					return time + duration * 100
				}
			},
			carMove() {
				setTimeout(()=>{
					this.marker.moveAlong({
						whiteDot: {
							path: this.markerData,
							duration: this.durationTime*1000
							// speed: 324, // 速度 单位：千米/小时
						},
					}, {
						autoRotation: true,
					});
				},100)
				
				this.trail.setData(this.trailData); //设置数据
			},
			// 创建轨迹图
			async initTrail() {
				let that = this
				this.trail = new TMap.visualization.Trail({
					pickStyle: function(item) {
						//轨迹图样式映射函数
						return {
							width: 6,
							color: "#f6cd0e",

						};
					},
					showDuration: Infinity, //动画中轨迹点高亮的持续时间
					playTimes: 1,
					playRate:this.calcPathTotal(pointData),
					// playRate: 327.67, //动画播放倍速，默认为1m/s
					// startTime: that.getTime('start'),
					// endTime: that.getTime('end', 15000),

					enableColorOffset: true
				}).addTo(this.map);
			},
			async initPath() {
				pointData.forEach((i) => {
					this.markerData.push(new TMap.LatLng(i.lat, i.lng))
					this.path.push([i.lat, i.lng])
					if (i.speed >= 5.05 && i.speed <= 5.13) {
						this.colorOffset.push(0.99)
					} else if (i.speed <= 5.58 && i.speed >= 5.34) {
						this.colorOffset.push(0.01)
					} else {
						this.colorOffset.push(0.5)
					}
				})
				this.trailData.push({
					path: this.path,
					// colorOffset: this.colorOffset
				})

			},
			// 初始化marker并添加至map图
			async initMarker() {
				let that = this
				this.marker = new TMap.MultiMarker({
					id: "whiteDot",
					map: this.map,
					styles: {
						"whiteDot": new TMap.MarkerStyle({
							width: 75,
							height: 75,

							faceTo: "map",
							rotate: 180,
							src: "https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/static/car/car2.png",
						}),
						start: new TMap.MarkerStyle({
							width: 22,
							height: 32,
							anchor: {
								x: 10,
								y: 27,
							},
							src: "https://mapapi.qq.com/web/miniprogram/demoCenter/images/marker-start.png",
						}),
						end: new TMap.MarkerStyle({
							width: 22,
							height: 32,
							anchor: {
								x: 2,
								y: 27,
							},
							src: "https://mapapi.qq.com/web/miniprogram/demoCenter/images/marker-end.png",
						}),
					},
					geometries: [{
							id: "whiteDot",
							styleId: "whiteDot",
							position: new TMap.LatLng(31.230525,121.473667),
						},
						{
							id: "start",
							styleId: "start",
							position: new TMap.LatLng(31.230525,121.473667),
						},
					],
				});

				this.marker.on('moving', function(e) {
					if (e.whiteDot) {
						that.roation = TMap.geometry.computeHeading(
							e.whiteDot.passedLatLngs[e.whiteDot.passedLatLngs.length - 2],
							e.whiteDot.passedLatLngs[e.whiteDot.passedLatLngs.length - 1]
						);
						that.position = TMap.geometry.computeDestination(that.marker.getGeometryById(
							'whiteDot').position, that.roation, 60);
					}
					
					// console.log(e)
					// console.log(that.position)
					let arr = e.whiteDot.passedLatLngs
					let len  = arr.length
					
					let Aposition = arr[len-1]
					// console.log(Aposition)

					// let  currentPos = e.car.position; // 当前 marker 的经纬度位置
					// this.map.setCenter(currentPos)

					this.map.easeTo({
						center: that.position,
						// center:Aposition,
						rotation: e.whiteDot.angle,
						zoom: 11,
						pitch: 50,
					}, {
						duration: 100,
					});
				});

				this.marker.on("move_ended", function() {
					console.log("轨迹播放完毕")
				})

			},

			async initMap() {
				let center = new TMap.LatLng(31.230525, 121.473667)
				this.map = new TMap.Map(document.getElementById('container'), {
					center: center, //设置地图中心点坐标
					zoom: 13, //设置地图缩放级别
					disableDefaultUI: true,
					pitch: 43.5, //设置俯仰角
					// mapType:'satellite_label'
					//  rotation: 45    //设置地图旋转角度
					//  panControl: false,
					//  zoomControl: false,
					 // mapStyleId: 'style1' //个性化地图样式设置
					// mapTypeId: new TMap.MapTypeId.SATELLITE
				});
			}

		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.btn {
		position: absolute;
		padding: 10px;
		top: 50px;
		left: 50px;
		background-color: azure;
		z-index: 1000;
		pointer-events: auto;
	}

	/deep/ .rotate-circle {
		display: none;
	}

	/deep/ .tmap-zoom-control {
		display: none;
	}

	.Ccon {
		position: relative;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
	}

	#container {
		width: 100vw;
		height: 110vh;
		position: relative;
	}
</style>